export function PageNameFilter() {
    return function (pageName: string, size: string) {
        if (!pageName) {
            return;
        }else{
            return pageName.replace('.html',"");
        } 
    }
}